import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { z } from 'zod'
import { getInvoiceSubmittalEditMode } from '~bank-invoices/service/invoiceSubmittalEditMode'

const schema = z.object({
  returnUrl: z.string().optional()
})

export const EditRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id/edit`,
    component: lazyRouteComponent(() => import('./EditInvoice')),
    validateSearch: (search) => schema.parse(search),
    beforeLoad: ({ params }) => {
      if ('id' in params) return { id: Number(params.id) }
      else throw new NotFoundError()
    },
    loader: async ({ context: { id } }) => await getInvoiceSubmittalEditMode({ id })
  })
